import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import CustomLoader from '../../CustomComponents/loader/CustomLoader';
import HttpClient from '../../utils/HttpClient';
import { useParams } from 'react-router-dom';
import moment from 'moment';

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "11px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const format1 = "DD-MM-YYYY, h:mm a"

const RewardHistory = () => {
    const [searchInput, setSearchInput] = useState('');
    const [AllData, setAllData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const params = useParams()

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "13.4rem"
        },
        {
            name: 'Reward Type',
            selector: row => row.type,
            width: "23.4rem"
        },
        {
            name: 'Points',
            selector: row => row.points,
            width: "18rem"
        },
        {
            name: 'Date',
            selector: row => row.createdOn,
            width: "13.4rem"
        },





    ];


    const getCategoryWiseData = async () => {
        setIsLoading(true);
        const data = {
            "userId": params?.id
        }
        const res = await HttpClient.requestData("users-rewards-histories", "POST", data);
        let apiData = []
        if (res && res?.status) {
            setIsLoading(false);
            apiData = res?.data?.map((item, i) => ({
                id: item?._id,
                sl: i + 1,
                type: item?.type?.toUpperCase(),
                points: item?.points,
                createdOn: moment(item?.createdOn).format(format1),
            }));

        } else {
            setIsLoading(false);
        }
        // Filter data based on search input
        const filteredData = apiData?.filter(item =>
            item?.type?.toLowerCase()?.includes(searchInput?.toLowerCase()) ||
            item?.points?.toString()?.includes(searchInput)


        );

        setAllData(filteredData);
    }
    useEffect(() => {
        if (params?.id) {
            getCategoryWiseData();
        }
    }, [params?.id, searchInput])
    return (
        <div className="d-flex justify-content-end">
            <div className="form-header">

                <CustomLoader loading={isLoading} />
                <section className="piechartsBox_area">
                    <div
                        style={headLineStyle}
                        className="page-headline"
                    >
                        REWARD HISTORY
                    </div>
                    <div className=" d-flex justify-content-end mb-2" >
                        <div className="Search_box">
                            <form className="form-inline">
                                <input
                                    className="form-control h-75"
                                    type="search"
                                    placeholder="Search"
                                    aria-label="Search"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                                <div className="Search_icon">
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </div>
                            </form>

                        </div>
                    </div>


                    <form>

                        <div>

                            <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded "
                                customStyles={customStyles}
                            />
                        </div>
                    </form>
                </section>
            </div>

        </div>
    )
}

export default RewardHistory